export enum RequestStatus{
  'open' = 'open',
  'failed' = 'failed',
  'completed' = 'completed',
  'cancelled' = 'cancelled',
}
